export enum EduTradingLessonsCountType {

    All = "all",
    Completed = "completed"
}
